<script>
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js";
import {computed, ref, watch} from "vue";
import {useRecruitmentPlanningStore} from "@/stores/Recruitment/RecruitmentPlanning.js";
import RecruitmentRequestFilter from "@/views/Request/RecruitmentRequest/Components/RecruitmentRequestFilter.vue";
import axios from "axios";

export default {
    name: "ListingModel",
    components: {RecruitmentRequestFilter},
    props: {
        type: String
    },
    setup(props) {
        const {
            loading,
            total,
            itemsPerPage,
            sortBy,
            descending,
            filter,
        } = useSharedData();

        const {transformFilterValues, formatedDate, formatedTime, getStatusColor} = useSharedMethod();

        const {$router, $i18n} = useTools();


        const recruitmentPlanningStore = useRecruitmentPlanningStore();
        const securityStore = useSecurityStore();

        sortBy.value = "date";
        descending.value = true;

        const headers = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                value: "sourcingRequestCode",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.occupation"),
                align: "left",
                value: "sourcingRequestOccupationName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.planning_date"),
                align: "left",
                value: "date",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.planning_time"),
                align: "left",
                value: "timing",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.recruitment_date"),
                align: "left",
                value: "sourcingRequestExpectedDate",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.requesting_agency"),
                align: "left",
                value: "sourcingRequestRequestingAgencyName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.applicant"),
                align: "left",
                value: "sourcingRequestWorkerLastName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("common.type"),
                align: "left",
                value: "typeName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.principal_expert"),
                align: "left",
                value: "principalExpertName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t('common.step'),
                align: "left",
                value: props.type === 'PLANNING' ? 'closed' : 'evaluationClosed',
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.post_number"),
                align: "left",
                value: "sourcingRequestPostNumber",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t('recruitment_request.candidate_number'),
                align: "left",
                value: "size",
                sortable: true,
                width: "0%"
            },
            {
               text: $i18n.t('recruitment_request.confirmed_number'),
                align: "left",
                value: "confirmedNumber",
                sortable: true,
            },
        ];

        if (props.type === 'EVALUATION') {
            headers.push(
                {
                    text: $i18n.t('recruitment_request.done_number'),
                    align: "left",
                    value: "doneNumber",
                    sortable: true,
                    width: "0%"
                },
                {
                    text: $i18n.t('recruitment_request.accepted_number'),
                    align: "left",
                    value: "acceptedNumber",
                    sortable: true,
                    width: "0%"
                },
                {
                    text: $i18n.t('recruitment_request.refused_number'),
                    align: "left",
                    value: "refusedNumber",
                    sortable: true,
                },
                {
                    text: $i18n.t('recruitment_request.absent_number'),
                    align: "left",
                    value: "absentNumber",
                    sortable: true,
                },
            );
        }

        let actions = [];
        if (props.type === 'EVALUATION') {
            actions.push(
                {
                    title: $i18n.t("common.lock"),
                    icon: 'mdi-lock',
                    color: 'grey darken-2',
                    access: (item) => item.updateOption,
                    disabled: (item) => item.evaluationClosed || item.sourcingRequestState === 'CLOSED',
                    func: (item) => {
                        $router.push({name: `${rootPath.value}.lock`, params: {id: item.id}})
                    },
                },
                {
                    title: $i18n.t('common.evaluate'),
                    icon: 'mdi-clipboard-text-clock',
                    color: 'blue darken -2',
                    access: (item) => item.updateOption,
                    disabled: (item) => item.evaluationClosed || item.sourcingRequestState === 'CLOSED',
                    func: (item) => {
                        view(item);
                    },
                }
            )
        } else {
            actions.push(
                {
                    title: $i18n.t("common.lock"),
                    icon: 'mdi-lock',
                    color: 'grey darken-2',
                    access: (item) => item.updateOption,
                    disabled: (item) => item.closed || item.sourcingRequestState === 'CLOSED',
                    func: (item) => {
                        $router.push({name: `${rootPath.value}.lock`, params: {id: item.id}})
                    },
                },
                {
                    title: $i18n.t("common.edit"),
                    icon: 'mdi-pencil-box-multiple',
                    color: 'orange',
                    access: (item) => item.updateOption,
                    disabled: (item) => item.closed || item.sourcingRequestState === 'CLOSED',
                    func: (item) => {
                        $router.push({name: `${rootPath.value}.edit`, params: {id: item.id}})
                    },
                },
                {
                    title: $i18n.t("common.delete"),
                    icon: 'mdi-trash-can',
                    color: 'red',
                    access: (item) => item.deleteOption,
                    disabled: (item) => item.closed || item.sourcingRequestState === 'CLOSED',
                    func: (item) => {
                        $router.push({name: `${rootPath.value}.delete`, params: {id: item.id}})
                    },
                })
        }


        const searchParams = ref({
            sortBy: "date",
            descending: true,
            page: 1,
            itemsPerPage: itemsPerPage
        });

        function handleSearch(params) {
            loading.value = true;
            recruitmentPlanningStore.setRecruitmentPlannings([]);
            total.value = 0;

            if (props.type === 'EVALUATION')
                filter.value.closed = true;

            loading.value = true;
            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;

            axios.get('/recruitmentPlannings', {params: transformFilterValues(filter.value)}).then((response) => {
                recruitmentPlanningStore.setRecruitmentPlannings(response.data.elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });
        }

        function findAll() {
            handleSearch(searchParams.value)
        }

        watch(() => filter.value, () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});

        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});

        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                filter.value[key] = null;
            });
        }

        const rootPath = computed(() => {
            if (props.type === 'PLANNING') {
                return 'recruitment_plannings';
            } else if (props.type === 'EVALUATION') {
                return 'recruitment_evaluations';
            }
        });

        function view(item) {
            $router.push({name: `${rootPath.value}.view`, params: {id: item.id}});
        }

        return {
            recruitmentPlanningStore,
            securityStore,
            searchParams,
            headers,
            actions,
            loading,
            total,
            filter,
            rootPath,
            findAll,
            view,
            clearFilter,
            formatedDate,
            formatedTime,
            getStatusColor
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="type === 'PLANNING' ? $t('module.recruitment_planning') : $t('module.recruitment_evaluation')"
            :total="total"
            show-filter
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <RecruitmentRequestFilter v-model="filter" planning/>
            </template>
            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
            </template>
            <template v-slot:content>
                <w-server-data-table
                    v-model="searchParams"
                    :actions="actions"
                    :headers="headers"
                    :items="recruitmentPlanningStore.recruitmentPlannings"
                    :loading="loading"
                    :total="total"
                    :root-path="rootPath"
                    :module="`RECRUITMENT_${type}`"
                    @rowDbClick="view"
                >

                    <template v-slot:item.sourcingRequestCode="{ item }">
                        <w-chip :text="item.sourcingRequestCode"/>
                    </template>
                    <template v-slot:item.sourcingRequestOccupationName="{ item }">
                        <w-inline-text bold :text="item.sourcingRequestOccupationName"/>
                    </template>
                    <template v-slot:item.date="{ item }">
                        <w-chip color="teal" :text="formatedDate(item.date)"/>
                    </template>
                    <template v-slot:item.timing="{ item }">
                        <w-chip color="teal" :text="formatedTime(item.timing)"/>
                    </template>
                    <template v-slot:item.sourcingRequestExpectedDate="{ item }">
                        <w-inline-text :text="formatedDate(item.sourcingRequestExpectedDate)"/>
                    </template>
                    <template v-slot:item.sourcingRequestRequestingAgencyName="{ item }">
                        <w-inline-text :text="item.sourcingRequestRequestingAgencyName"/>
                    </template>
                    <template v-slot:item.sourcingRequestWorkerLastName="{ item }">
                        <w-inline-text :text="item.sourcingRequestWorkerName"/>
                    </template>
                    <template v-slot:item.typeName="{ item }">
                        <w-inline-text :text="item.typeName"/>
                    </template>
                    <template v-slot:item.principalExpertName="{ item }">
                        <w-inline-text :text="item.principalExpertName"/>
                    </template>
                    <template v-slot:item.closed="{ item }">
                        <w-chip v-if="item.closed" color="grey darken-2" :text="$t('common.locked')"/>
                        <w-chip v-else color="blue" text="En Cours"/>
                    </template>
                    <template v-slot:item.evaluationClosed="{ item }">
                        <w-chip v-if="item.evaluationClosed" color="grey darken-2" :text="$t('common.locked')"/>
                        <w-chip v-else color="blue" :text="$t('common.in_progress')"/>
                    </template>
                    <template v-slot:item.sourcingRequestPostNumber="{ item }">
                        <w-chip outlined :text="item.sourcingRequestPostNumber"/>
                    </template>
                    <template v-slot:item.size="{ item }">
                        <w-chip outlined :text="item.size"/>
                    </template>
                    <template v-slot:item.confirmedNumber="{ item }">
                        <w-chip outlined :text="item.confirmedNumber"/>
                    </template>
                    <template v-slot:item.doneNumber="{ item }">
                        <w-chip color="blue darken-2" :text="item.doneNumber"/>
                    </template>
                    <template v-slot:item.acceptedNumber="{ item }">
                        <w-chip color="teal" :text="item.acceptedNumber"/>
                    </template>
                    <template v-slot:item.refusedNumber="{ item }">
                        <w-chip color="red" :text="item.refusedNumber"/>
                    </template>
                    <template v-slot:item.absentNumber="{ item }">
                        <w-chip color="orange" :text="item.absentNumber"/>
                    </template>
                </w-server-data-table>
            </template>
        </w-app>

        <router-view/>
    </div>
</template>